import { render, staticRenderFns } from "./Game_Name.vue?vue&type=template&id=610d13bc&scoped=true"
import script from "./Game_Name.vue?vue&type=script&lang=js"
export * from "./Game_Name.vue?vue&type=script&lang=js"
import style0 from "./Game_Name.vue?vue&type=style&index=0&id=610d13bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610d13bc",
  null
  
)

export default component.exports